var React = require('react');

function FullLine (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"fill":"#FFFFFF","d":"M95.226,0H7.206C3.227,0,0,3.228,0,7.206s3.226,7.205,7.206,7.205h88.02c3.979,0,7.205-3.227,7.205-7.205\r\n\t\t\tS99.204,0,95.226,0z"}))));
}

FullLine.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"102.431px","height":"14.411px","viewBox":"0 0 102.431 14.411","enableBackground":"new 0 0 102.431 14.411","xmlSpace":"preserve"};

module.exports = FullLine;

FullLine.default = FullLine;
